module.exports = __webpack_public_path__ + "img/introduce_dialog_bg.f450e6a3.png";